<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<Addst :showlocal="showlocal" @closeLocal="closeLocal"></Addst>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>在线考试</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input 
								style="width: 220px;"
								v-model="getdata.title" 
								placeholder="输入名称查询"
								@input="getdata.page = 1;totalPage = 0;dataList();"></el-input>
						</div>
						<div>
							<el-button size="small" type="primary" @click="delAll">一键删除</el-button>
							<el-button type="primary" size="small" @click="showlocal = true;">新建试题分类</el-button>
						</div>
					</div>
					<div class="selectdata">
						<el-table
							:header-cell-style="{background:'#f5f7fa',color:'#000'}"
							:data="tableData"
							border
							stripe
							style="width:100%"
							 @selection-change="selectList"
							:row-style="{height:'50px'}">
							<el-table-column 
								type="selection"
								width="50"
							></el-table-column>
							<el-table-column 
								prop="name"
								label="试题分类"
							></el-table-column>
							<el-table-column 
								prop="gu_name"
								width="200"
								label="创建人"
							></el-table-column>
							<el-table-column 
								prop="count"
								width="80"
								align="center"
								label="试题数量"
							></el-table-column>
							<el-table-column 
								prop=""
								width="110"
								label="创建时间">
								<template slot-scope="scope">
									{{$changeTime(scope.row.addtime)}}
								</template>
							</el-table-column>
							<el-table-column 
								width="170"
								align="center"
								label="操作">
								<template slot-scope="scope">
									<div class="btn_list">
										<span @click="showDetail(scope.row)">详情</span>
										<div v-if="scope.row.myself==1" @click="open(scope.row)">
											<span v-if="scope.row.open != 1">公开</span>
											<span v-if="scope.row.open == 1">取消公开</span>
										</div>
										<span 
										@click="del(scope.row)"
										v-if="scope.row.gu_name==$store.state.user.userinfo.dw">删除</span>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { xxjy,dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import DelData from '@/components/delToast.vue'
	import Addst from './components/add_st.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					id: this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					dwid:this.$store.state.user.userinfo.dwid,
					title:"",
					status:"",
					page: 1
				},
				delList:[],
				showlocal:false,
				tableData:[],
				totalPage:0,
				studyNum:0,
				studyTime:0
			}
		},
		components:{Page,DelData,Addst,myTables},
		created(){that = this;},
		methods:{
			// 数据
			dataList(){
				xxjy.questionClassList(that.getdata).then(res => {
					if(res.data.pagedata.length>0){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				})
			},
			// 关闭新建弹窗
			closeLocal(){
				that.showlocal = false;
				that.dataList();
			},
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			// 一键删除
			selectList(value){
				let arr=[];
				value.forEach((item,key) => {
					arr.push(item.id)
				})
				that.delList =arr;
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			// 部分禁用删除
			selectEnable(row, rowIndex) {
				if (row.dwid == that.$store.state.user.userinfo.id) {
					return true
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						xxjy.delQuestionClass({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			showDetail(data){
				that.$router.push({
					path:'/stlist',
					query:{
						id:data.id,
						dwid:that.getdata.dwid
					}
				})
			},
			// 编辑
			edit(data){
				this.$router.push({
					path:'/add_zt',
					query:{
						id:data.id,
						type:'edit',
						dwid:data.dwid,
						flag:data.flag,
					},
				})
			},
			// 公开/取消公开
			open(item){
				xxjy.openQuestionClass({
					id:item.id,
					open:item.open==0?1:0
				}).then(res => {
					if(res.code == 200){
						Message.success(res.msg)
					}else{
						Message.error(res.msg)
					}
					that.getdata.page = 1;
					that.dataList();
				})
			},
			// 导出表格
			daochu(){
				dwgl.exportPartyOrgan(that.getdata);
			}
		},
		mounted() {
			var that = this;
			that.$emit('selectTop',5)
			that.dataList();
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian{
			width: 100px;
			height: 60px;
			object-fit: cover;
		}
		.zttit{
			font-size: 16px;
			font-weight: bold;
		}
		.textCount{
			font-size: 14px;
		}
		.intro{
			font-size: 14px;
		}
	}
</style>

